module.exports = __webpack_public_path__ + "img/5.b44c7413.svg";